import { useMemo } from "react";

import {
    useBaseIdentityAttrs,
    useCustomerIdentityAttrs
} from "@/components/fastshift/analytics";
import { SourceKey } from "@/components/fastshift/analytics/constants";

export const useResourcesPageAnalyticsData = (isDomainScoped: boolean) => {
    const baseIdentityAttrs = useBaseIdentityAttrs();
    const customerIdentityAttrs = useCustomerIdentityAttrs();

    return useMemo(() => {
        const sourceKey = isDomainScoped
            ? SourceKey.FASTSHIFT_PORTAL_CUSTOMER_RESOURCES_SCREEN
            : SourceKey.FASTSHIFT_PORTAL_PARTNER_RESOURCES_SCREEN;

        const identityAttrs = isDomainScoped
            ? customerIdentityAttrs
            : baseIdentityAttrs;

        return {
            sourceKey,
            identityAttrs
        };
    }, [isDomainScoped, baseIdentityAttrs, customerIdentityAttrs]);
};
